export default __webpack_public_path__ + "static/media/lamp-red-full.ec79d885.svg";